import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelMode } from 'devextreme/common';
import { DxButtonModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
import { CtlSasAboneKisiAramaComponent } from './ctl-sas-abone-kisi-arama/ctl-sas-abone-kisi-arama.component';
import { CtlSasAboneKisiService } from './ctl-sas-abone-kisi.service';
import { DkGlobalUserSettingsService } from '../../../services/dk-global-user-settings.service';

@Component({
  selector: 'dk-ctl-sas-abone-kisi',
  standalone: true,
  imports: [CommonModule,
     DxButtonModule,
     CommonModule,
     DxPopupModule,
     DxScrollViewModule,
     DxToastModule,
    CtlSablonComponent,
    CtlSasAboneKisiAramaComponent
  ],
    providers:[CtlSasAboneKisiService],
  templateUrl: './ctl-sas-abone-kisi.component.html',
  styleUrls: ['./ctl-sas-abone-kisi.component.scss'],
})
export class CtlSasAboneKisiComponent implements OnInit,OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = this.globalSettings.globalLabelMode;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;public isFirst = true;
  public control!: any;
  controlName = "vSasAboneKisi";
  @Input() code!: any;
  @Input() validationRulesMap!:any[];
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: CtlSasAboneKisiService, private utilsService: UtilsService, private ortakService: OrtakService,
    private globalSettings:DkGlobalUserSettingsService
  ) {}


  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
        this.service.setParams(this.isReadOnly,this.isBindCheck)
  }
  ngOnChanges(changes: SimpleChanges) {
        
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.isReadOnly,this.isBindCheck)
      }
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }

  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = null;
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: number, isSetData?: boolean) {

    this.data = this.service.getData(Number(code),this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad?result[0].Ad + " " + result[0].Soyad:result[0].Unvani;
        this.code = result[0].AboneKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.AboneKod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

